import { render, staticRenderFns } from "./vehicle-registation-card.vue?vue&type=template&id=b8c2a1b6&"
import script from "./vehicle-registation-card.vue?vue&type=script&lang=js&"
export * from "./vehicle-registation-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports